<template>
    <div 
        class="flex flex-col"
    >
        <CRMDetailRow
            v-for="crmAction in openCampaignActions"
            :key="crmAction.id"
            :crmAction="crmAction"
        />
        <CRMDetailRow
            v-for="crmAction in currentCampaignActions"
            :key="crmAction.id"
            :crmAction="crmAction"
        />
    </div>
</template>

<script setup>
import { defineProps, computed } from 'vue';
import CRMDetailRow from './CRMDetailRow.vue';
import { sortCRMDetailsByResolvedDate as sortByResolvedDate, sortCRMDetailsByDueDate as sortByDueDate } from '@/composables/CompanyCRMTools';

const props = defineProps(['company', 'endIndex'])

const currentCampaignId = computed(() => {
    return props.company.campaign ? props.company.campaign.id : null
})

const currentCampaignDetails = computed(() => {
    if(currentCampaignId.value && props.company.crm_actions) {
        return props.company.crm_actions.filter(action => {return action.campaign_id == currentCampaignId.value})
    }
    return []
})

// Open details come first -- soonest due date first, the same order the CRM
// details page lists them in -- since they're the ones still needing work.
const openCampaignActions = computed(() => {
    return currentCampaignDetails.value.filter(action => {return !action.resolved_date}).sort(sortByDueDate)
})

// endIndex only caps the resolved details: open details are what the cell is
// there to surface, so they aren't dropped to make room for history.
const currentCampaignActions = computed(() => {
    let crmActionsArray = currentCampaignDetails.value.filter(action => {return action.resolved_date}).sort(sortByResolvedDate)
    if(props.endIndex) {
        if(crmActionsArray.length -1 >= props.endIndex) {
            return crmActionsArray.slice(0, props.endIndex)
        } else {
            return crmActionsArray
        }
    } else {
        return crmActionsArray
    }
})

</script>